import React, { Component, Fragment } from "react";
import { Tabs, Card, Button, Spin, message, Alert } from "antd";
import BasicLayout from "layouts/BasicLayout";
import GeneralTab from "./components/GeneralTab";
import ProxyTab from "./components/ProxyTab";
import CaptchaTab from "./components/CaptchaTab";
import GoogleNoCaptchaTab from "./components/GoogleNoCaptchaTab";
import ContentTab from "./components/ContentTab";
import { inject, observer } from "mobx-react";
import SpinnerTab from "./components/SpinnerTab";
import IndexerTab from "./components/IndexerTab";
import RankerXIndexTab from "./components/RankerXIndexerTab";
import BlockedSitesTab from "./components/BlockedSitesTab";
import co from "co";

const TabPane = Tabs.TabPane;

@observer
class MainTabs extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeKey: this.props.initTab ? this.props.initTab : "general"
		};
		// console.log("Active Key is: " + this.state.activeKey);
	}

	setActiveKey = activeKey => {
		this.setState({ activeKey });
	};

	handleTabChange = activeKey => {
		this.setState({ activeKey });
	};

	render() {
		const {
			generalTab,
			proxyTab,
			captchaTab,
			googleNoCaptchaTab,
			contentTab,
			spinnerTab,
			indexerTab,
			rankerXIndexerTab,
			blockedSitesTab,
			saveOptionsButton
		} = this.props;
		return (
			<Tabs
				activeKey={this.state.activeKey}
				animated={false}
				tabBarExtraContent={saveOptionsButton}
				onChange={this.handleTabChange}
			>
				<TabPane tab="General" key="general" forceRender={true}>
					{generalTab}
				</TabPane>
				<TabPane tab="Proxy" key="proxy" forceRender={true}>
					{proxyTab}
				</TabPane>
				<TabPane tab="Captcha" key="captcha" forceRender={true}>
					{captchaTab}
				</TabPane>
				<TabPane
					tab="Google Captcha"
					key="googleNoCaptcha"
					forceRender={true}
				>
					{googleNoCaptchaTab}
				</TabPane>
				<TabPane tab="Content" key="content">
					{contentTab}
				</TabPane>
				<TabPane tab="Spinner" key="spinner">
					{spinnerTab}
				</TabPane>
				<TabPane tab="Indexer" key="indexer">
					{indexerTab}
				</TabPane>
				<TabPane tab="RankerX Indexer" key="rankerxIndexer">
					{rankerXIndexerTab}
				</TabPane>
				<TabPane tab="Blocked Sites" key="blockedSites">
					{blockedSitesTab}
				</TabPane>
			</Tabs>
		);
	}
}

@inject("rootStore")
@observer
class OptionsPage extends Component {
	saveOptions = () => {
		const {
			rootStore: { optionsStore }
		} = this.props;
		// optionsStore.remoteSaveOptions();
		co(
			function*() {
				let response = yield this.generalTab.validateForm();
				if (response != null) {
					this.mainTabs.setActiveKey("general");
					message.error("Please fix the problems below before saving options", 3);
					return;
				}
				response = yield this.captchaTab.validateForm();
				if (response != null) {
					this.mainTabs.setActiveKey("captcha");
					message.error("Please fix the problems below before saving options", 3);
					return;
				}
				response = yield this.googleNoCaptchaTab.validateForm();
				if (response != null) {
					this.mainTabs.setActiveKey("googleNoCaptcha");
					message.error("Please fix the problems below before saving options", 3);
					return;
				}
				optionsStore.remoteSaveOptions();
			}.bind(this)
		);
	};
	render() {
		const {
			rootStore: { optionsStore }
		} = this.props;

		if (optionsStore.options == null) {
			return <div />;
		}

		const saveOptionsButton = (
			<Button type="primary" onClick={this.saveOptions}>
				Save
			</Button>
		);

		const generalTab = (
			<GeneralTab
				options={optionsStore.options}
				ref={generalTab => {
					if (generalTab != null) {
						this.generalTab = generalTab.wrappedInstance;
					} else {
						this.generalTab = null;
					}
				}}
			/>
		);
		const proxyTab = (this.proxyTab = <ProxyTab />);
		const captchaTab = (this.captchaTab = (
			<CaptchaTab
				options={optionsStore.options}
				ref={captchaTab => {
					if (captchaTab != null) {
						this.captchaTab = captchaTab.wrappedInstance;
					} else {
						this.captchaTab = null;
					}
				}}
			/>
		));
		const googleNoCaptchaTab = (this.googleNoCaptchaTab = (
			<GoogleNoCaptchaTab
				options={optionsStore.options}
				ref={googleNoCaptchaTab => {
					if (googleNoCaptchaTab != null) {
						this.googleNoCaptchaTab = googleNoCaptchaTab.wrappedInstance;
					} else {
						this.googleNoCaptchaTab = null;
					}
				}}
			/>
		));
		const contentTab = (this.contentTab = <ContentTab />);
		const spinnerTab = (this.spinnerTab = <SpinnerTab />);
		const indexerTab = (this.indexerTab = <IndexerTab />);
		const rankerXIndexerTab = (this.rankerXIndexerTab = <RankerXIndexTab />);
		const blockedSitesTab = (this.blockedSitesTab = <BlockedSitesTab />);
		const props = {
			generalTab,
			proxyTab,
			captchaTab,
			googleNoCaptchaTab,
			contentTab,
			spinnerTab,
			indexerTab,
			rankerXIndexerTab,
			blockedSitesTab,
			saveOptionsButton
		};

		let spinning = optionsStore.ui.savingOptions == true;				
		let captchaAlert = <></>;
		let primaryGoogleCaptchaService = optionsStore.stateForm.googleNoCaptchaService.value;
		console.log(primaryGoogleCaptchaService);
		if (primaryGoogleCaptchaService == "DeathByCaptcha" || primaryGoogleCaptchaService == "ImageTypers" || primaryGoogleCaptchaService == "AntiCaptcha") {
			let message = <h1>You are using {primaryGoogleCaptchaService}, we <b>DON'T RECOMMEND</b> using {primaryGoogleCaptchaService}, which is slow and expensive. <br/>We recommend <a href="https://0captcha.com/#comparision" target="_blank">0captcha</a>, which we co-develop, which is faster, more accurate and 3 times cheaper.</h1>
			captchaAlert = (
				<Alert
					message={message}
					type="error"
					closable      
    			/>						
			)
		}
		return (
			<Fragment>		    
				{captchaAlert}
				<Card>
					<Spin spinning={spinning}>
						<MainTabs {...props} initTab={optionsStore.ui.initTab} ref={mainTabs => (this.mainTabs = mainTabs)} />
					</Spin>
					{/* <Tabs
						defaultActiveKey="general"
						animated={false}
						tabBarExtraContent={saveOptionsButton}
					>
						<TabPane tab="General" key="general">
							<GeneralTab options={optionsStore.options} />
						</TabPane>
						<TabPane tab="Proxy" key="proxy" forceRender={true}>
							<ProxyTab />
						</TabPane>
						<TabPane tab="Captcha" key="captcha">
							<CaptchaTab options={optionsStore.options} />
						</TabPane>
						<TabPane tab="Google No Captcha" key="googleNoCaptcha">
							<GoogleNoCaptchaTab options={optionsStore.options} />
						</TabPane>
						<TabPane tab="Content" key="content">
							<ContentTab />
						</TabPane>
						<TabPane tab="Spinner" key="spinner">
							<SpinnerTab />
						</TabPane>
						<TabPane tab="Indexer" key="indexer">
							<IndexerTab />
						</TabPane>
						<TabPane tab="RankerX Indexer" key="rankerxIndexer">
							<RankerXIndexTab />
						</TabPane>
						<TabPane tab="Blocked Sites" key="blockedSites">
							Content of Tab Pane 3
						</TabPane>
					</Tabs> */}
				</Card>
			</Fragment>
		);
	}
}

export default OptionsPage;
